import React from "react";
// import { Icon } from "@iconify/react";
// import qrcodeOutline from "@iconify/icons-ant-design/qrcode-outline";
// import mobileOutline from "@iconify/icons-ant-design/mobile-outline";

// const lastElement = () => {
//   const myUrl = window.location.href;
//   const url_array = myUrl.split("/");
//   return url_array[url_array.length - 1];
// };

const qrbullets = {
    marginLeft: -15,
    //marginTop: -8,
  };

  const mySection = {
    width: "100vw",
    minHeight: "800px",
    //backgroundImage: "url('assets/images/auth-bg.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: 0,
    marginTop: -75,
    position: "relative",
    display: "flex",
    alignItems: "center",
  };

class VcountPartner extends React.Component {
  render() {
    return (
        <section
        //className="feature"
        style={mySection}
      >
        {/* id and classname was feature */}
        <div className="feature-decor">
          <div className="feature-circle1">
            <img src="assets/images/feature2.png" alt="" />
          </div>
        </div>
        <div className="container">
          <div className="row">

            <h2 className="title" style={{textAlign:"center"}}>
              <span>ΝΕΑ ΑΠΟΚΛΕΙΣΤΙΚΗ ΣΥΝΕΡΓΑΣΙΑ της QRSTAND® με τη V-COUNT® για την Ελλαδα.</span>
            </h2>
            <div className="col-lg-6">
              <img
                src="assets/images/vcounter_logo.png"
                className="img-fluid"
                alt=""
                style={{
                    marginBottom: "35px",
                    marginTop: "10px"
                }}
              />
               <p style={{textAlign:"justify"}}>
                  Η QRSTAND προσανατολισμένη στην ανέπαφη ανταλλαγή πληροφοριών εκθέτη - επισκέπτη και στη παραγωγή στατιστικών στοιχείων μέσω του QRSTAND app, επεκτείνεται.
Η νέα αποκλειστική συνεργασία με την κορυφαία εταιρεία ανίχνευσης και καταγραφής κίνησης στον κόσμο, V-COUNT , έρχεται να λύσει το μεγάλο πρόβλημα της διαχείρισης των περιορισμών συγχρωτισμού στους πολυσύχναστους χώρους (Εκθεσιακοί Χώροι, S-Ms, Malls, Αεροδρόμια κλπ).Με την αξιοποίηση των στατιστικών που μπορούν να παραχθούν η παρακολούθηση του κόστους, η μεγιστοποίηση των εσόδων και η βελτίωση του εκάστοτε marketing plan είναι γεγονός.
                  </p>

            </div>
            <div className="col-lg-6">
            <p>
                  Η εφαρμογή της V-COUNT με 15 χρόνια εμπειρίας και  συνεργασίας με κορυφαίες εταιρείες όπως SWAROVSKI -  FORD - SEPHORA - MARKS & SPENCER - IKEA διαθέτει τις εξής παροχές:
                  </p>
                  {/* <div className="row">
                    <div class="col-md-6">
                    <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <p><h3> On line θερμικός χάρτης συγκέντρωσης με ανάλυση στοιχείων για περιοχές μεγάλου ή μικρού ενδιαφέροντος αντιστοίχως</h3></p>
                      </div>
                    </div>
                    <div class="col-md-6">
                    <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3 style={{wordWrap:"break-word"}}>Queue Management (διαχείριση προτεραιότητας) στα σημεία ενδιαφέροντος (ταμεία, δοκιμαστήρια, κλπ).</h3>
                      </div>
                    </div>
                    <div class="col-md-6">
                    <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3>Καταμέτρηση ατόμων που βρίσκονται μέσα σε ένα χώρο με ακρίβεια 99,9% . Δυνατότητα αποκλεισμού προσωπικού, δυνατότητα αποκλεισμού παιδιών, δυνατότητα καταμέτρησης ατόμων σε ομάδες, κλπ.</h3>
                      </div>
                    </div>
                    <div class="col-md-6">
                    <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3>  Mood - Age - Gender Analysis (ανάλυση της διάθεσης, της ηλικίας και του φύλου).</h3>
                      </div>
                    </div>
                  </div> */}
                <div className="row">
                    <div class="col-12">
                    <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <p><h3> On line θερμικός χάρτης συγκέντρωσης με ανάλυση στοιχείων για περιοχές μεγάλου ή μικρού ενδιαφέροντος αντιστοίχως</h3></p>
                      </div>
                    </div>
                    <div class="col-12">
                    <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3 style={{wordWrap:"break-word"}}>Queue Management (διαχείριση προτεραιότητας) στα σημεία ενδιαφέροντος (ταμεία, δοκιμαστήρια, κλπ).</h3>
                      </div>
                    </div>
                    <div class="col-12">
                    <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3>Καταμέτρηση ατόμων που βρίσκονται μέσα σε ένα χώρο με ακρίβεια 99,9% . Δυνατότητα αποκλεισμού προσωπικού, δυνατότητα αποκλεισμού παιδιών, δυνατότητα καταμέτρησης ατόμων σε ομάδες, κλπ.</h3>
                      </div>
                    </div>
                    <div class="col-12">
                    <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3>  Mood - Age - Gender Analysis (ανάλυση της διάθεσης, της ηλικίας και του φύλου).</h3>
                      </div>
                    </div>
                  </div>
              {/* <div className="row">
                <div className="col-12 col-md-6">
                  <ul className="feature-style">
                  <li>
                      <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <p><h3> On line θερμικός χάρτης συγκέντρωσης με ανάλυση στοιχείων για περιοχές μεγάλου ή μικρού ενδιαφέροντος αντιστοίχως</h3></p>
                      </div>
                    </li>
                    <li>
                      <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3> Καταμέτρηση ατόμων που βρίσκονται μέσα σε ένα χώρο με ακρίβεια 99,9% . Δυνατότητα αποκλεισμού προσωπικού, δυνατότητα αποκλεισμού παιδιών, δυνατότητα καταμέτρησης ατόμων σε ομάδες, κλπ.</h3>
                      </div>
                    </li>

                  </ul>
                </div>
                <div className="col-12 col-md-6 sm-m-top">
                  <ul className="feature-style">
                    <li>
                      <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3>Queue Management (διαχείριση προτεραιότητας) στα σημεία ενδιαφέροντος (ταμεία, δοκιμαστήρια, κλπ).</h3>
                      </div>
                    </li>
                    <li>
                      <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3>
                        Mood - Age - Gender Analysis (ανάλυση της διάθεσης, της ηλικίας και του φύλου).
                        </h3>
                      </div>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
          <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
              <center><h3>
                Για μια σύντομη αλλά πιο αναλυτική εικόνα, δείτε το πιο κάτω video.
                </h3></center>
                <br/>
                <iframe title="VCount-Services" width="100%" height="630" src="https://www.youtube.com/embed/UxhVPaRxe-s" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

              </div>
              <div className="col-md-2"></div>

          </div>
        </div>
      </section>




    );
  }
}

export default VcountPartner;



// WEBPACK FOOTER //
// ./src/components/partners/vcountpartner.js